export default {
  getInforOrder: state => state.inforOrder,
  getOrderNo: state => state.orderNo,
  getInforMerchant: state => state.inforMerchant
}
